import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  public permissionsChange = new BehaviorSubject<any[]>([]);

  private permissionsUrl = environment.baseUrl + environment.api + 'permissions' + environment.surfix;
  private archivePermissionsUrl =
    environment.baseUrl + environment.api + 'reports/archive_interval' + environment.surfix;

  setArchivePermission: Subject<any> = new Subject();

  public permissions = [];

  constructor(private http: HttpClient, private authService: AuthService) {}

  getUserPermissions() {
    return this.permissions;
  }

  refreshUserPermissions() {
    return this.http
      .get(this.permissionsUrl + '/pharmacy', {
        headers: this.authService.getJwtAuthHeaders(),
      })
      .pipe(
        map((permissions: any[]) => {
          this.permissions = permissions.map((permission) => {
            return permission.sym;
          });
          this.permissionsChange.next(this.permissions);
          return this.permissions;
        })
      );
  }

  getArchivePermissions(reportId, vehicleId: any, groupId) {
    let idToRequest = '';
    let textToRequest = 'vehicle_id';
    if (Array.isArray(vehicleId)) {
      textToRequest = 'vehicle_ids';
      vehicleId.forEach((el) => {
        idToRequest += el + ',';
      });
      idToRequest = idToRequest.substr(0, idToRequest.length - 1);
      if (idToRequest.length <= 0) {
        idToRequest = '0';
        textToRequest = 'vehicle_id';
      }
    } else if (vehicleId > -1) {
      idToRequest = vehicleId;
      textToRequest = 'vehicle_id';
    } else if (groupId > -1) {
      idToRequest = groupId;
      textToRequest = 'vehicle_group_id';
    }

    return this.http.get(
      this.archivePermissionsUrl +
        '/' +
        reportId +
        '?' +
        textToRequest +
        '=' +
        idToRequest,
      {
        headers: this.authService.getJwtAuthHeaders(),
      }
    );
  }

  public hasPermission(permission: string): boolean {
    return this.permissions.indexOf(permission) !== -1;
  }
  public hasNotPermission(permission: string): boolean {
    return this.permissions.indexOf(permission) === -1;
  }
}
